import { useState } from 'react';

import GlobalCookieBanner from '@skyscanner-internal/global-components/cookie-banner';
import logger from 'saddlebag-logger';

import type { CookieBannerProps } from '@shared/types/global-components/cookie-banner-props';

type Props = CookieBannerProps & {
  isProductionEnv: boolean;
};

const CookieBanner = (props: Props) => {
  const [isOpen, setIsOpen] = useState(true);

  return isOpen ? (
    <GlobalCookieBanner
      {...props}
      logger={logger}
      onPolicyAcceptClick={() => setIsOpen(false)}
    />
  ) : null;
};

export default CookieBanner;
